import React from "react";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";

const DeleteConfirmationModal = ({ open, title, message, onConfirm, onCancel, error }) => {
  return (
    <Modal open={open} className="flex items-center justify-center">
      <Box className="bg-white text-center p-4 rounded-2xl shadow-md w-[90%] max-w-md mx-auto">
        <h2 className="text-xl font-bold mb-4">{title}</h2>
        <p className="mb-6">{message}</p>
        {error && <p className="text-red-500">{error}</p>}
        <div className="flex justify-center space-x-4">
          <button
            onClick={onConfirm}
            className="bg-red-500 text-white px-4 py-2 rounded-lg"
          >
            Yes, Remove
          </button>
          <button
            onClick={onCancel}
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
          >
            Cancel
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default DeleteConfirmationModal;
